import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from '../services/app-loading.service';
import { SKIP_LOADER } from '../constants/http-context.constants';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  // Requests tagged with SKIP_LOADER (e.g. background calls) bypass the spinner.
  if (req.context.get(SKIP_LOADER)) {
    return next(req);
  }

  const loadingService = inject(LoadingService);
  loadingService.show();

  return next(req).pipe(
    finalize(() => {
      loadingService.hide();
    }),
  );
};
